import { createSelector } from 'reselect';
import { AppState } from '../createStore';
import { getFormattedAddressWithComment } from '@wix/restaurants-client-logic';

export const formattedAddressWithCommentSelector = createSelector(
  [(state: AppState) => state.session.restaurant.address],
  (address) => getFormattedAddressWithComment(address),
);
